import { Facebook } from 'lucide-react';
import cybernestLogo from '@/assets/images/Hero/cybernest.png';
import flowLogo from '@/assets/images/Hero/flow.png';

const Footer = () => {
  return (
    <footer className="bg-white px-4 py-6 text-center">
      <hr />
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-4 pt-10 sm:justify-around sm:px-6 md:gap-10 md:px-10">
        {/* Left - Copyright */}
        <p className="text-xs text-gray-700">
          © 2025 Entrepreneurship Educators Association of the Philippines
        </p>

        {/* Center - Logos */}
        <div className="flex flex-wrap items-center gap-2 text-xs text-gray-700">
          <span className="font-medium">Powered By:</span>
          <a href="https://www.cybernestsolution.com/" target="_blank">
            <img
              src={cybernestLogo}
              alt="Cybernest Logo"
              className="h-9 w-auto border-r object-contain pr-2"
            />
          </a>
          <a href="https://www.cybernestsolution.com/">
            <img
              src={flowLogo}
              alt="Flow Logo"
              className="h-4 w-auto object-contain"
            />
          </a>
        </div>

        {/* Right - Social Icons */}
        <div className="flex items-center gap-3">
          <a
            href="https://facebook.com/ENEDAph"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary hover:opacity-75"
          >
            <Facebook size={18} strokeWidth={2} />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
